import {
  LIST_TAGS,
  CREATE_TAG,
  UPDATE_TAG,
} from '@/data/actions/modules/general';

export default [
  {
    path: '/settings/tags',
    component: () => import(/* webpackChunkName: "tags" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_TAGS,
    },
  },
  {
    path: '/settings/tags/create',
    component: () => import(/* webpackChunkName: "tags" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: CREATE_TAG,
    },
  },
  {
    path: '/settings/tags/:id/edit',
    component: () => import(/* webpackChunkName: "tags" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: UPDATE_TAG,
    },
  },
];
